export default function Footer() {
  return (
    <footer className="relative py-12 px-4 sm:px-6 lg:px-8 bg-white/50 backdrop-blur-sm border-t border-stone-200">
      <div className="max-w-6xl mx-auto text-center">
        <p className="text-stone-600 font-light tracking-wide">
          © 2024 Nikki. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

